import { getCustomerPendingPlan, getCustomerPendingTier } from 'src/data/subscription';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useIsSubscriptionPendingDowngrade = () => {
  const currentCustomer = useCurrentCustomer();

  return !!getCustomerPendingTier(currentCustomer) || !!getCustomerPendingPlan(currentCustomer);
};
